import { render, staticRenderFns } from "./MarketPlaceFacebook.vue?vue&type=template&id=47480611&"
import script from "./MarketPlaceFacebook.vue?vue&type=script&lang=js&"
export * from "./MarketPlaceFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports